import {
	FETCH_OVERTIMES_SUCCESS,
	FETCH_OVERTIME_SUCCESS,
} from "../../constants/ActionTypes";

const initialSettings = {};

export default (state = initialSettings, action) => {
	switch (action.type) {
		case FETCH_OVERTIMES_SUCCESS: {
			return { ...state, index: action.payload };
		}
		case FETCH_OVERTIME_SUCCESS: {
			return { ...state, show: action.payload };
		}
		default:
			return state;
	}
};
